import { CantileverButton } from 'components/CantileverButton'
import { ToolInfo } from 'features/kestrelViewer/tutorial/types'
import React from 'react'

import {
  ButtonContainer,
  SubmenuHighlight,
  TooltipArrowLeft,
  TooltipBox,
  TooltipContainer,
  TooltipHighlight,
  TooltipText,
  TooltipTitle,
} from './TutorialStyledComponents'

interface ToolbarTooltipsProps {
  currentTool: ToolInfo
  onNext: () => void
  onPrevious: () => void
}

export const ToolbarTooltips: React.FC<ToolbarTooltipsProps> = ({
  currentTool,
  onNext,
  onPrevious,
}) => {
  const isSubmenu = currentTool.id === 'submenu-indicator'

  return (
    <>
      {isSubmenu ? (
        <SubmenuHighlight $top={currentTool.top} />
      ) : (
        <TooltipHighlight $top={currentTool.top} />
      )}
      <TooltipContainer $top={currentTool.top} $isSubmenu={isSubmenu}>
        <TooltipBox>
          <TooltipArrowLeft />
          <TooltipTitle>{currentTool.title}</TooltipTitle>
          <TooltipText>{currentTool.description}</TooltipText>
          <ButtonContainer style={{ marginTop: '1rem' }}>
            <CantileverButton onClick={onPrevious}>Previous</CantileverButton>
            <CantileverButton primary onClick={onNext}>
              Next
            </CantileverButton>
          </ButtonContainer>
        </TooltipBox>
      </TooltipContainer>
    </>
  )
}
